import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";

const CURRENT_YEAR = new Date().getFullYear();

export function AppFooter() {
  return (
    <footer className="border-t bg-background py-3 text-xs text-muted-foreground sm:text-[13px]">
      <div className="mx-auto max-w-7xl px-4">
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center">
          <span className="text-foreground/90">
            &copy; 2022-{CURRENT_YEAR}{" "}
            <a
              href="https://www.researchly.at/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-foreground hover:underline"
            >
              Researchly.at
            </a>{" "}
            – Alle Rechte vorbehalten
          </span>
          <span className="mx-1 text-[10px] text-muted-foreground/50">•</span>
          <a
            href="https://www.researchly.at/impressum/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Impressum
          </a>
          <span className="mx-1 text-[10px] text-muted-foreground/50">•</span>
          <a
            href="https://www.researchly.at/datenschutz/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Datenschutz
          </a>
          <span className="mx-1 text-[10px] text-muted-foreground/50">•</span>
          <Dialog>
            <DialogTrigger asChild>
              <Button
                variant="link"
                size="sm"
                className="h-auto p-0 leading-none"
              >
                KI‑Hinweis
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-md">
              <DialogHeader>
                <DialogTitle>Hinweis zu KI-Auswertungen</DialogTitle>
              </DialogHeader>
              <p className="text-sm text-muted-foreground">
                Researchly nutzt KI-basierte Analysen. Die Ergebnisse können
                ungenau oder fehlerhaft sein.
              </p>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </footer>
  );
}
